export async function list({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.work.list(payload);
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }
}
